import { useFormContext } from 'react-hook-form';
import { DefaultAssetAllocationDTO } from '../../../../../../../../api/useAccountsOptionsQuery';
import { getAllocations } from '../../../../../../../Holdings/utils/getAllocations';
import { getWeightedAllocation } from '../../utils/getWeightedAllocation';
import {
  AccountHoldingDTO,
  AllocationTaxStatusDTO,
} from '../../../../../../../../api/useAccountsQuery';
import { FormFields } from '../../../../AccountForm.meta';
import { useAccountFormContext } from '../../../../context/useAccountFormContext';

interface UseSpecificPositionsParams {
  assetAllocationTaxStatus: AllocationTaxStatusDTO | null;
}

export const useSpecificPositions = ({ assetAllocationTaxStatus }: UseSpecificPositionsParams) => {
  const { watch } = useFormContext<FormFields>();

  const [accountType, positions] = watch(['bankAccount.AccountType', 'bankAccount.Positions']);

  const {
    options: { DefaultAssetAllocation },
  } = useAccountFormContext();

  const { AssetAllocation: assetAllocationOptions } = DefaultAssetAllocation.find(
    defaults => defaults.AccountType === accountType,
  ) as DefaultAssetAllocationDTO;

  if (!positions || (positions && positions.length === 0)) {
    return { data: null };
  }

  const specificPositionsList =
    assetAllocationTaxStatus === null
      ? positions
      : positions.filter(position => position.TaxStatus === assetAllocationTaxStatus) || [];

  const aggregatedPositions = (specificPositionsList as AccountHoldingDTO[]).map(getAllocations);

  if (aggregatedPositions.length === 0) {
    return {
      data: null,
    };
  }

  const weightedAllocation = getWeightedAllocation(aggregatedPositions);

  const chartValues = assetAllocationOptions.map(asset => ({
    ...asset,
    y: weightedAllocation ? weightedAllocation[asset.id] * 100 : asset.y * 100,
  }));

  return {
    data: {
      aggregatedPositions,
      chartValues,
    },
  };
};
